 <template>
  <div v-on:click="closeSiteBasket($event)" class="appContainer">
    <div class="page">

      <!--**************************************
        RIGHT SECTION
      **********************************-->

      <div v-if="!disablePictureWall" class="rightSection u-pull-right">

           <site-basket></site-basket>

           <div class="rightMenu">

              <!-- overlays -->
              <saved-walls-picker ref="savedWalls"> </saved-walls-picker> <!-- Saved wall picker -->

              <!-- LEFT -->
              <!-- Mobile menu opener -->
              <div v-on:click="toggleMobileMenu" class="button mobileBottomMenuToggle">
                <i v-if="!mobileBottomMenuActive" class="fa fa-chevron-up"></i>
                <i v-if="mobileBottomMenuActive" class="fa fa-chevron-down"></i>
                {{ $t('menu') }}
              </div>

              <div v-on:click="toggleSavedWallsPicker" class="button">
                <i v-if="!savedWallsPickerActive" class="fa fa-chevron-down hide-for-mobile"></i>
                <i v-if="savedWallsPickerActive" class="fa fa-chevron-up hide-for-mobile"></i>
                <i v-if="!savedWallsPickerActive" class="fa fa-chevron-up show-for-mobile-inline"></i>
                <i v-if="savedWallsPickerActive" class="fa fa-chevron-down show-for-mobile-inline"></i>
                {{ $t('savedWalls') }}
              </div> <!-- button -->

              <!-- Mobile menu toggleable, visible without toggle in desktop -->
              <div v-bind:class="{ mobileBottomMenuItems: true, active: mobileBottomMenuActive }">
                <div v-on:click="openSave" v-bind:disabled="price <= 0" class="button"> <i class="fa fa-save"></i> {{ $t('save') }} </div>
                <div v-on:click="share" class="button"> <i class="fa fa-share"></i> {{ $t('share') }} </div>
                <div v-on:click="resetPictureWall" class="button"> <i class="icon-picture-wall"></i>  {{ $t('createNew') }} </div>
                <a v-if="locale == 'sv'" target="_blank" :href="wgURL + '/general/Desenio-picture-wall.pdf'">
                  <div class="button"> <i class="fa fa-file-text-o"></i> Ritningar </div>
                </a>
              </div> <!-- bottomMobileMenuItems -->

              <!-- RIGHT -->
              <div class="buyRightContainer u-pull-right">

                <div v-on:click="toggleSiteBasket" class="cartContainer u-pull-left">
                  <div class="qty"> {{ siteBasketQty }} </div>
                  <i  class="cart-icon"></i>
                </div> <!-- cartContainer-->

                <a v-if="!device.isMobile" :href="checkoutUrl">
                  <div class="fullButton u-pull-right text-center cta black">
                    {{ $t('toCheckout') }} <div v-html="siteBasketSum" class="basketSum"> </div>
                  </div>
                </a>

                <div v-on:click="buy" class="fullButton u-pull-right text-center cta black addToCartMobile">
                  <loader classes="" :inline="true" identifier="buyButton"></loader>
                  <span class="largePhone"> {{ $t('addToCart') }} <img class="bagImg" :src="wgURL + '/icons/shopbag.png'" alt=""></span>
                  <span class="smallPhone"> {{ $t('addToCartSmall') }} <img class="bagImg" :src="wgURL + '/icons/shopbag.png'" alt=""></span>
                  <div class="basketSum"> <price :inline="true"></price> </div>
                </div>

              </div> <!-- buyRightContainer -->

              <div class="breadcrumbs hide-for-mobile">
                <a :href="$t('pageUrl')">{{ $t('breadcrumbPrints') }} /</a>
                <a :href="$t('breadcrumbInspLink')"> {{ $t('breadcrumbInsp') }} /</a>
                <a :href="$t('breadcrumbGwLink')" class="active"> {{ $t('breadcrumbGw') }}</a>
              </div>

          </div> <!-- rightMenu -->

          <article-filter-wg></article-filter-wg>
          <picture-wall ref="pictureWall"></picture-wall>

      </div> <!-- rightSection -->

      <!--**************************************
        LEFT SECTION
      **********************************-->

      <div v-bind:class="{ leftSection: true, rightBorder: true,  floatLeft: true, invisible: hideLeftMenu }">

        <!-- Close icon -->
        <div v-if="currentPicker" class="closePicker hide-for-mobile">
          <div class="inner" v-on:click="closePickers('all')">
            <i class="icon-close"></i>
          </div>
        </div>

        <!-- Progress bar -->
        <!--<step-progress-bar></step-progress-bar>-->

        <div v-bind:class="{ logo: true, hideOnMobile: currentLeftTitle }">
          <img v-on:click="goToDesenio" src="https://checkout.desenio.se/frontend/view_desktop/design/logos/desenio-logo-black.svg">
        </div>

        <!-- Top panel displaying current states -->
        <div v-if="currentPicker" class="topPanel relative row">
          <div class="name tiny-heading u-pull-left"> {{ currentLeftTitle }} </div>
        </div>

        <!-- pickers -->
        <loader classes="cover dimmer" identifier="picker"></loader>
        <picker></picker> <!-- General picker -->
        <frame-picker></frame-picker> <!-- Frame picker -->
        <article-picker></article-picker> <!-- Article picker -->
        <basket></basket> <!-- Basket -->

        <!-- Bottom actions -->
        <div class="bottomActions">
          <!-- Next / prevstep -->
          <next-step v-if="currentPicker" ></next-step>
        </div>

        <!-- menu -->
        <div class="leftMenu" v-bind:class="{ active: showMenu }">

          <div v-on:click="openPicker('backgrounds')" v-bind:class="{ menuItem: true, hoverFade: true, done: steps.background}">
            <div class="icon">
              <i class="icon-pictures"></i>
            </div> <!-- icon -->
            <span class="number">1 <i class="fa fa-check"></i></span>
            <span class="name raleway"> {{ $t('pick') }} {{ $tc('background', 1) }}</span>
          </div>

          <div v-on:click="openPicker('pictureWalls')" v-bind:class="{ menuItem: true, hoverFade: true, done: steps.pictureWall}">
            <div class="icon">
              <i class="icon-picture-wall"></i>
            </div> <!-- icon -->
            <span class="number">2 <i class="fa fa-check"></i></span>
            <span class="name raleway">{{ $t('pick') }} {{ $tc('picturewall', 1) }}</span>
          </div>

          <div v-on:click="openBasket" id="pickMotifs" v-bind:class="{ menuItem: true, hoverFade: true, done: steps.motifs}">
            <div class="icon">
              <i class="icon-article"></i>
            </div> <!-- icon -->
            <span class="number">3 <i class="fa fa-check"></i></span>
            <span class="name raleway">{{ $t('pick') }} {{ $tc('motifs', 1) }}</span>
          </div>

          <div v-on:click="openFramePicker" v-bind:class="{ menuItem: true, hoverFade: true, done: steps.frames}">
            <div class="icon">
              <i class="icon-frame"></i>
            </div> <!-- icon -->
            <span class="number">4 <i class="fa fa-check"></i> </span>
            <span class="name">{{ $t('frameYourMotifs') }} </span>
          </div>
        </div> <!--leftMenu -->

        <!-- Buy -->

        <div v-if="!currentPicker" class="buyLeft">
          <price></price>

          <div v-if="buyButtonActive">
            <div v-on:click="buy" class="button cta adapted buyButtonLeft hoverFade">
              <loader classes="" :inline="true" identifier="buyButton"></loader>
              {{ $t('addToCart') }}
              <img class="bagImg" :src="wgURL + '/icons/shopbag.png'" alt="">
              </div>
          </div>
          <div v-else>
            <div class="button cta adapted buyButtonLeft" style="background-color:#888;border:none">
               <loader classes="" :inline="true" identifier="buyButton"></loader>
              {{ $t('addToCart') }}
              <img class="bagImg" :src="wgURL + '/icons/shopbag.png'" alt="">
              </div>
          </div>
        </div> <!-- buyLeft -->

      </div> <!-- leftSection -->

    </div> <!-- page -->

  </div>
</template>

<script>
import PictureWall from 'components/PictureWall/PictureWall'
import Picker from 'components/Picker/Picker'
import FramePicker from 'components/Picker/FramePicker'
import ArticlePicker from 'components/Picker/ArticlePicker'
import SavedWallsPicker from 'components/Picker/SavedWallsPicker'
import Tooltip from 'components/Misc/Tooltip'
import ArticleFilterWg from 'components/Filter/ArticleFilterWG'
import PriceNotifier from 'components/Misc/PriceNotifier'
import Basket from 'components/Basket/Basket'
import LoginTest from 'components/Misc/LoginTest'
import StepProgressBar from 'components/Misc/StepProgressBar'
import NextStep from 'components/Misc/NextStep'
import SiteBasket from 'components/Basket/SiteBasket'


export default {
  components: {
    PictureWall,
    Picker,
    FramePicker,
    ArticlePicker,
    SavedWallsPicker,
    Tooltip,
    ArticleFilterWg,
    Basket,
    LoginTest,
    StepProgressBar,
    NextStep,
    SiteBasket
  },

  data: function(){
    return{
      menuActive: 0,
      mobileBottomMenuActive: 0,
      buyActive: false,
      buyButtonActive: true,
      wgURL: window.appSettings.wgURL,
    }
  },

  computed: {

    pkr(){
      return this.$store.state.currentPicker;
    },

    siteBasketQty(){
      return this.$store.state.siteBasket.qty;
    },

    siteBasketSum(){
      return this.$t('currencyPrefix') + this.$store.state.siteBasket.sum + this.$t('currencySuffixBuy')
    },

    price(){
      return this.$store.state.price;
    },

    disablePictureWall(){
      return this.$store.state.disablePictureWall;
    },

    savedWallsPickerActive(){
      return this.$store.state.savedWallsPickerActive;
    },

    showMenu(){
      return !this.currentPicker;
    },

    buyLoading(){
      if(isset(his.$store.state.loading['buyButton']))
        return this.$store.state.loading['buyButton'];
      return false;
    },

    hideLeftMenu(){
      return this.$store.state.hideLeftMenu;
    }

  },

  methods: {

    /*-----------------------------------------------
      Go to Desenios homepage
    -----------------------------------------------*/

    goToDesenio(){

      var self = this

      this.promtSave(function(){
        window.location = self.$t('pageUrl')
      });

    },

    /*-----------------------------------------------
      Open/toggle pickers, using events
    -----------------------------------------------*/

    openPicker(type){

      // Open picker
      window.eventHub.$emit('openPicker', type);

    },

    openFramePicker(){

      // Open picker
      window.eventHub.$emit('openFramePicker');

    },

    toggleSavedWallsPicker(){
      window.eventHub.$emit('toggleSavedWalls');
    },

    /*--------------------------------------------------
      Open basket (resides in left panel) using events
    --------------------------------------------------*/

    toggleSiteBasket(){
      window.eventHub.$emit('toggleSiteBasket');
    },

    closeSiteBasket(e){
      window.eventHub.$emit('closeSiteBasket', e);
    },

    openBasket(){
      window.eventHub.$emit('openBasket');
    },

    /*------------------------------------------------------------------
      Functions for bottom right menu, open modals and menus, buy etc
    ------------------------------------------------------------------*/

    toggleMobileMenu(){
      this.mobileBottomMenuActive = ! this.mobileBottomMenuActive;
      window.eventHub.$emit('closeRightMenus', 'mobileMenu');
      window.eventHub.$emit('toggleMobileMenu');
    },

    resetPictureWall() {
      this.clearPictureWall();
      this.buyButtonActive = true;
    },

    openSave(){

      var self = this;

      if(!self.ifArticlesExists()){
        window.eventHub.$emit('openModal', {
          modal: 'message',
          data: {
            title: self.$t('errorTitle'),
            message: self.$t('needsArticlesSave') ,
            confirmTxt: self.$t('close'),
            confirm: true,
            onConfirm: function(){
              window.eventHub.$emit('closeModal');
            }
          }
        });

        return false;
      }


      window.eventHub.$emit('openModal', {modal: 'save' });
    },

    share(){

      var self = this;

      // Check if we have something to share

      if(!self.ifArticlesExists()){
        window.eventHub.$emit('openModal', {
          modal: 'message',
          data: {
            title: self.$t('errorTitle'),
            message: self.$t('needsArticlesShare') ,
            confirmTxt: self.$t('close'),
            confirm: true,
            onConfirm: function(){
              window.eventHub.$emit('closeModal');
            }
          }
        });

        return false;
      }


      // Prompt to save if needed first
      self.promtSave(function(){

        // If still not saved, abort
        if(self.$store.state.updated)
          return false;

        // Open share modal
      window.eventHub.$emit('openModal', { modal: 'share' });
      },
      {
        title: self.$t('shareSaveTitle'),
        message: self.$t('shareSaveText'),
      })


    },


    // Buy function
    buy(){

      var self = this;
      var utc = new Date().toJSON().slice(0,10).replace(/-/g,'-');

      if(self.buyActive){
        return false;
      }

      // Prevent double click and fallback
      self.buyActive = true;
      setTimeout(function(){
        self.buyActive = false;
      }, 5000);

      self.$store.commit('startLoading', 'buyButton');

      if(!self.$store.state.updated){
        self.makeBuy();
        return true;
      }

      this.buyButtonActive = false;

      // Create image if saving
      self.createImage(function(response){

          // Save and pass data
          window.apiHandler.save(function(data){

            if(data.status){

              // Save the current ID if user is going back
              var Cookies = require('js-cookie')
              Cookies.set('cartSave', {
                'id': data.savedWall.id,
                'identifier': data.savedWall.identifier
              }, { expires: 999, path: '/' });

              // Do buy
              self.makeBuy();

              self.trackEvent('added to cart step');

            }
            // If error occured
            else{
              self.promptError();
            }

            self.buyButtonActive = true;
            
          },{
            name: self.$t('addedToCartDate', { date: utc }),
            picture: response.filename
          });

      })

    },

    makeBuy(){
      var self = this;
      self.$store.commit('stopLoading', 'buyButton');
      window.apiHandler.buy(function(data){
        window.eventHub.$emit('closeRightMenus', 'all');
        window.eventHub.$emit('openSiteBasket');
        self.$store.commit('stopLoading', 'buyButton');
        setTimeout(function(){
          self.buyActive = false;
        }, 1700);
      });
    },

    checkStock(){

      var self = this;

      var articles = window.apiHandler.buildChosenArticles({includeFrames: true});

      var foundCopper = false;
      var foundSilver = false;

      var message = "";

      if(message){

        window.eventHub.$emit('openModal', {
            modal: 'message',
            data: {
              title: self.$t('noStock'),
              message: message ,
              confirmTxt: self.$t('close'),
              confirm: true,
              messageClass: "longtext",
              onConfirm: function(){
                window.eventHub.$emit('closeModal');
              }
            }
        });

      }

    }

  },


  mounted(){

    var self = this;

    // Close mobile menu if right menus should be closed
    window.eventHub.$on('closeRightMenus', function (type) {
      if(type != 'mobileMenu')
        self.mobileBottomMenuActive = false;
    });

    // When showing error outside of vue
    window.eventHub.$on('promptError', function (message) {
      self.promptError(message);
    });

    // When to set url
    window.eventHub.$on('setSavedUrl', function (id) {
        self.setSavedUrl(id)
    });

    // If we should load a saved wall by url
    var savedData = self.getSavedData()

    if(savedData){
        savedData.checkOwner = true;
        window.eventHub.$emit('pickSavedWall', savedData);
    }

    // If we should load a saved wall after purchase
    var Cookies = require('js-cookie')
    var cartSave =  Cookies.get('cartSave')

    if(typeof cartSave != 'undefined'){

      cartSave = JSON.parse(cartSave);

      if(cartSave.id && cartSave.identifier){
        window.eventHub.$emit('pickSavedWall', cartSave);
        Cookies.remove('cartSave')
        window.eventHub.$emit('closeModal')
      }

    }

    window.addEventListener('orientationchange', function(){
        this.screen_width
    });
    
  
  }

}
</script>


<style lang="scss">

.addToCartMobile{
  display: none !important;

  @media screen and (max-width: 844px) {
    display: inline-block !important;
  }
}

/* Right section, picture wall area */
.rightSection{
  width: 80%;
  height: 100%;
  position: relative;
  overflow: hidden;

  /* Right menu below picture wall */
  .rightMenu{

    background: white;

    .mobileBottomMenuToggle {
      display: none;
      @media(max-width: 844px) {
        display: inline;
      }
    }

    .breadcrumbs {
      margin-left: 10px;

      a {
        color: #b3b3b3;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 9px;
        font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
        letter-spacing: 1px;
      }

      .active {
        color: #363636;
      }

      @media (max-width: 844px) { display: none; }
    }

    /* Mobile */
    @media screen and (max-width: 844px) {
      height: calc(45px + env(safe-area-inset-bottom));
      position: absolute;
      bottom: calc(0px);
      width: 100%;
      z-index: 9;
    }

    /* Tablets and desktop */
    @media screen and (min-width: 845px) {
      height: 71px;
    }

    /* Button styles */
    &>.button, .mobileBottomMenuItems .button{
      margin: 7px -3px 0px 10px;
      padding: 10px 20px;
      line-height: normal;
      height: auto;
      position: relative;
      z-index: 99;

      /* Tablet */

      @media screen and (min-width: 845px) and (max-width: 1250px) {
        margin: 7px -3px 0px 3px;
        font-size: 10.5px !important;
        padding: 10px 10px !important;
      }

      /* Mobile */
      @media screen and (max-width: 844px) {

        margin:0;
        border: 0px;
        line-height: 45px;
        padding: 0 8px;
        border-right: 1px solid #EAEAEA;
        font-size: 10px !important;

      }

       /* Small Mobile */
      @media screen and (max-width: 610px) {
        padding: 0 10px;
        font-size: 10px !important;
      }

      /* Icon adjustment */
      .icon-picture-wall{
        margin-right: 2px;
        display: inline-block;
        position: relative;
        top: 0.5px;
      }

    }

    .buyRightContainer{
      display: inline-block;

      @media (max-width: 844px) {
        a { display: none; }
      }
    }

    .cartContainer{

      line-height: 49px;
      margin-right: 15px;
      position: relative;
      cursor: pointer;

      .cart-icon:after{
        font-family: 'icomoon' !important;
        content: "\e900";
        font-size: 18px;
        font-style: normal;
      }

      .qty{
        position: absolute;
        font-size: 11px;
        top: -12px;
        right: -9px;
        font-weight: 500;
      }

    }

    /* Full buttons like "Buy now" */
    .fullButton{
      height: 100%;
      line-height: 49px;
      padding: 0px 20px;
      cursor: pointer;
      position: relative;
      z-index: 99;
      text-transform: uppercase;

      &.cta{
        margin: 6px 6px 0px 10px;
        padding: 12px 44px;
        line-height: normal;
        height: auto;
        position: relative;
        font-size: 12px;
        font-weight: 400;
        z-index: 99;
        font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
        background: black;
        color: white;
      }

      .basketSum{
        display: inline;
        font-family: "Lato";
        font-weight: 400;
        margin-left: 5px;
      }

      /* Mobile */
      @media screen and (max-width: 844px) {
        line-height: 45px;
        padding: 0px 10px;

        &.cta{
          padding: 10px 14px;
          font-size: 11px;
          margin: 5px 6px 0px 10px;
          margin-left: 2px;
        }

        .smallPhone{
          display: none;
        }

      }

      /* Small nobile */
      @media screen and (max-width: 610px) {
        &.cta{
          padding: 9px 8px;
          margin-top: 8px;
          font-size: 10px;

          .largePhone{
            display: none;
          }

          .smallPhone{
            display: inline;
          }

        }
      }

    }

    /* Bottom mobile menu toggle item */

    /* Item containe */
    .mobileBottomMenuItems{

      display: inline-block;

      /* Mobile */
      @media screen and (max-width: 844px) {
        display: inline-block;
        position: absolute;
        background: white;
        z-index: 9;
        left: 0;
        border-bottom: 1px solid #eaeaea;
        width: 100%;
        pointer-events: none;
        opacity: 0;

        -webkit-transform: translate3d(0,0,0);
        transform: translate3d(0,0,0);
        -webkit-transition: -webkit-transform 0.2s;
        transition: -webkit-transform 0.2s;
        -o-transition: transform 0.2s;
        transition: transform 0.2s;
        transition: transform 0.2s, -webkit-transform 0.2s;
        -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
        -o-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
        transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);

      }

      &.active{
        opacity: 1;
        pointer-events: all;
        transform: translate3d(0,-46px,0);
      }

    }


  }

}

/* Left section, menu and pickers */
.leftSection{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: calc(20% - 1px);
  position: relative;
  z-index: 2;
  background: white;

  .closePicker{
    position: absolute;
    right: 0;
    top: 35px;
    z-index: 9;

    .inner{
      padding: 10px 10px;
      font-size: 24px;
      cursor: pointer;
    }
  }

  /* Logo */
  .logo{
    text-align: center;
    padding: 10px 0px 5px 0px;
    cursor: pointer;

    img{
      max-height: 29px;
      width: auto;
    }

    /* Mobile */
    @media screen and (max-width: 844px) {
      img{
          max-width: 90px;
        }
    }
  }

  .loadContainer {
    position: absolute;
    top: calc(50% - 55px); transform: translateY(-50%);
  }

  .buyButtonLeft {

    position: relative;

    .loadContainer{
      position: static !important;
      transform: translateY(0);
    }

  }

  /* Left menu action buttons */
  .bottomActions{
    width: 100%;
    padding: 10px;
    z-index: 9;
    background: white;

     /* Mobile */
    @media screen and (max-width: 844px) {
      padding: 3px;
      font-size: 10px;
    }

    .close{
      padding: 11px;
      width: 100%;
      font-size: 12px;

      /* Mobile */
      @media screen and (max-width: 844px) {
        padding: 8px;
        font-size: 10px;
      }

    }
  }

  /* Top panel */
  .topPanel{
    padding: 5px 0;
    font-size: 15px;
    text-align: center;
    flex: 1;

    .name{
      text-align: center;
      text-align: left;
      padding-left: 10px;
      font-size: 12px;
      width: 100%;
    }

    /* Mobile */
    @media screen and (max-width: 844px) {

      padding: 5px;
      padding-bottom: 0px;
      padding-left: 0px;

      .name{
        font-size: 10px !important;
        text-align: center;
        width: 100%;
      }
    }
  }
  /* Left menu, steps */
  .leftMenu{
    height: 100%; width: 100%; top: 50px;
    position: absolute;
    transform: translate3d(-100%,0,0);
    overflow: auto;

    &.active{
      transform: translate3d(0,0,0);
    }

    /* Scroll when height is not enough */
    @media screen and (max-height: 566px) {
      height: calc(100% - 46px);
    }

    @media screen and (max-height: 668px) and (min-width: 844px) {
      height: calc(100% - 135px);
      overflow-y: scroll;
    }

    @media (min-width: 845px) and (max-width: 926px) {
      padding-bottom: 15px;
    }
  }

  .menuItem{
    span{ display: block; }
    text-align: center;
    padding: 17px 20px;
    cursor: pointer;
    transition: color .25s ease;
    position: relative;

    /* Iphone X */
    @media screen and (max-height: 375px) {
      padding: 8.5px 3px !important;
    }

    @media screen and (min-width: 845px) and (max-width: 1370px) {
      padding: 9px 20px;
    }

    @media screen and (min-height: 500px) and (max-height: 650px) and (min-width: 1000px) {

      padding: 3px 20px !important;

      .icon-pictures{
        font-size: 26px !important;
      }

      .icon-article,.icon-frame{
        font-size: 30px !important;
      }

      .icon-picture-wall{
        font-size: 24px !important;
      }

      span{
        font-size: 12px !important;
      }

      .name{
        font-size: 10px !important;
      }

    }

    &:hover{
      color: #888;
    }

    .fa-check{
      font-size: 11px;
      position: absolute;
      margin-top: 7px;
      margin-left: -24px;
      display: none;

    }

    &.done{
      color: #999999;

      .fa-check{
        display: inline-block;
      }

    }

    .icon{
      font-size: 30px;
      position: relative;
    }

    /* Icon adjustments */
    .icon-article,.icon-frame{
      font-size: 40px;
    }

    .icon-pictures{
      font-size: 33px;
    }

    .numbers{
      font-size: 24px;
      margin-bottom: 3px;
    }

    .name{
      font-size: 12px;
      text-transform: uppercase;;
    }

    /* Mobile */
    @media screen and (max-width: 844px) {

      padding: 12px 3px;

      .name{
        font-size: 10px;
      }

      .icon{
        font-size: 14px;
      }

      /* Icon adjustments */
      .icon-article,.icon-frame{
        font-size: 20px;
      }

      .icon-pictures{
        font-size: 20px;
      }

      .number{
        font-size: 14px;
      }

      .numbers{
        font-size: 15px;
        margin-bottom: 3px;
      }

    }

     /* Larger phones */
    @media screen and (max-width: 732px) {
      padding: 8px 3px;

    }

  }

   @media screen and (min-height: 500px) and (max-height: 650px) and (min-width: 1000px) {
    .priceContainer{
      font-size: 19px !important;
      margin-bottom: 3px !important;
    }

    .buyButtonLeft{
      font-size: 11px !important;
      margin-bottom: 7px !important;
    }
  }

  /* Buy */
  .buyLeft{
    position: absolute;
    bottom: 0px;
    text-align: center;
    width: 100%;
    display: none;
    z-index: 9;

    /* Only show when height is enough (in mobile it will show in the left corner) */
    @media screen and (min-width: 844px) {
      display: block;
    }

    .priceContainer{
      display: block;
      font-size: 22px;
      margin-bottom: 12px;

      @media screen and (max-height: 600px) {
          font-size: 14px;
          margin-bottom: 6px;
      }
    }

    .buyButtonLeft{
      padding: 17px 3px;
      width: 90%;
      background: black;
      color: white;
      font-size: 12px;
      margin-bottom: 10px;

       /* Tablet */
      @media screen and (max-width: 1024px) {
        font-size: 11px;
        width: 94%;
      }

      @media screen and (max-height: 600px) {
        padding: 12px 3px;
      }

    }


  }



}

.bagImg {
  height: 17px;
  margin-bottom: -3px;

  @media screen and (max-width: 844px) {
    height: 13px;
    margin-bottom: -2px;
  }
}


</style>



// WEBPACK FOOTER //
// Home.vue?53bb8d42